const ProductTitle = ({
  productName
}) => <h1 className="text-productDetails-text mb-3 text-lg font-medium md:text-xl" data-sentry-component="ProductTitle" data-sentry-source-file="ProductTitle.jsx">
    {productName}
  </h1>;
export default ProductTitle;